import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AnnotationCriteria } from '../common';

@Injectable({
  providedIn: 'root'
})
export class AnnotationService {
  constructor(private http: HttpClient) { }

  save(annotation: any) {
    return this.http.post(environment.app.apiUrl + 'annotation/save', annotation).toPromise();
  }
  remove(id: any) {
    return this.http.post(environment.app.apiUrl + `annotation/remove/${id}`, null).toPromise();
  }

  search(criteria: AnnotationCriteria) {
    return this.http.post<any[]>(environment.app.apiUrl + 'annotation/search', criteria).toPromise();
  }
}
